// extracted by mini-css-extract-plugin
export default {"container":"AccountDetails_container__KtRPt","account":"AccountDetails_account__sz3Dh","name":"AccountDetails_name__48eEd","email":"AccountDetails_email__NkrpU"};